import React from 'react';
import {Card} from "../../../../../components/card/card.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import InputDateTime from "../../../../../components/input/input-datetime.jsx";
import {FaPlus, FaTrash} from "react-icons/fa";
import Button from "../../../../../components/button/button.jsx";
import {v4} from "uuid";

const AnimalsGenericList = ({state, setState, target}) => {
    const stateValue = state[target]

    const handleInput = (id, value, itemId) => {
        setState(prev => ({
            ...prev,
            [target]: prev[target].map(item => {
                if (item.itemId === itemId) return { ...item, [id]: value };

                return item;
            })
        }));
    }

    const removeItem = (itemId) => {
        setState(prev => ({...prev, [target]: prev[target].filter(i => i.itemId !== itemId)}))
    }

    const addItem = () => {
        const newItem ={
            itemId: v4(),
            name: "",
            date: ""
        }

        setState(prev => ({...prev, [target]: [...prev[target], newItem]}))
    }

    const title = {
        vaccines: "Vacinas",
        procedures: "Consultas",
        trainings: "Treinamentos",
    }

    const addText = {
        vaccines: "vacina",
        procedures: "consulta",
        trainings: "treinamento",
    }

    return (
        <Card>
            <Card.Header>
                <Card.Title>{title[target]}</Card.Title>
            </Card.Header>

            <Card.Body className={"space-y-3"}>
                {
                    stateValue?.map(i => (
                        <section className={"flex gap-4"} key={i.itemId}>
                            <InputForm
                                id={`name-${target}-${i.itemId}`}
                                classNameWrapper={"flex-1"}
                                label={"Nome"}
                                value={i.name}
                                onChange={({target: {id, value}}) => handleInput("name", value, i.itemId)}
                            />
                            <InputDateTime
                                id={`date-${target}-${i.itemId}`}
                                label={"Data"}
                                dateFormat="L"
                                classNameWrapper={"flex-1"}
                                selected={i.date}
                                onChange={(date) => handleInput("date", date, i.itemId)}
                            />

                            <Button target={"danger"} onClick={() => removeItem(i.itemId)}>
                                <FaTrash />
                            </Button>
                        </section>
                    ))
                }

                <Button onClick={addItem}>
                    <FaPlus /> Adicionar {addText[target]}
                </Button>
            </Card.Body>
        </Card>
    );
};

export default AnimalsGenericList;